import { render, staticRenderFns } from "./PurchaseVanTab.vue?vue&type=template&id=55257e04&scoped=true"
import script from "./PurchaseVanTab.vue?vue&type=script&lang=js"
export * from "./PurchaseVanTab.vue?vue&type=script&lang=js"
import style0 from "./PurchaseVanTab.vue?vue&type=style&index=0&id=55257e04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55257e04",
  null
  
)

export default component.exports